import { ILicenseConsumptionInfo } from '../types/ILicenseConsumptionInfo';
import { Request } from './Request';

export class GetServerLicensingConsumptionInfoRequest extends Request<{}, ILicenseConsumptionInfo> {
  constructor() {
    super('getServerLicensingConsumptionInfo', {});
  }
}
